// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}
//
jQuery(document).ready(function($) {
	$('a[href="#decorating-services"]').on('click', function(e){
		e.preventDefault();
		//
		var link = $(this).attr('href');
		var linkOffset = $(link).offset().top - $('#wrapper-navbar').height();
		//
		$('html, body').animate({
			scrollTop:linkOffset
		}, 'slow');
	});
});